import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSecondaryButton]'
})
export class SecondaryButtonDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {

    const classes = ['btn', 'btn-secondary', 'text-uppercase', 'text-light', 'fw-bold', "fs-button-small"];

    classes.forEach((className) => {
      this.renderer.addClass(this.el.nativeElement, className);
    });
  }
}
